var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    y: 4,
    width: 40,
    height: 32,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAgCAYAAABgrToAAAADWElEQVRYhc2YW4hOURTHf3PT0FyMTCRDJOQ6I3kawoNLHtxKiSGXxGRKvLg0SJ4kJEmRfEYUk6KQaxqicSkiHhhTZh7I/ZLbXGjVOrVt57LP+Tx8//r69ll7r7X/++y111r7ZLGjvS9QB0wks3AdqMoFUkquBXifIRR7KKeUEJwMvAQGAh0ZQE6QA7wQbtkq+JBB5FAuwoncgAHdgXIfeae6wTPgp+Nkw4ClIXOZuAnUm4IgpRpgW4ihX8A5YBPwNGJSIbfOgZxglivBnAhDXYDZwDRgKnAjZOx2oAHIDhnj4Z/Furz2MHTVKDAEaAsY9xE4m3QCl1V9BkqM33DguNE/AKgM0ZctfqtEo36nkhD8bRl9opO2G2MGh+jnOM6Dus5fSLrFnUrcQ3vI2IP6S4QkBAuBrUCeIWsKGV8ETHCc6zHwXNsS6jpclIp1az0UWKe8FbgVor85Rphp1owmL6FMgrXrGywOkMvJXaFxMQgp9UEXP7yj/5N0fFO6YWYhcCFizCNgbUy7Kz1dF4LfgWptjwbWGH3zgJPGs2Sfftr+CqyOSQz11+nabnAhKNt3RNtZwCitgARzgZnAGWARUGvo7UxATmrTY9qWSHHeNT55kNCyBPhiyPZrHNxtyOQkbolpu1xTYpk+X5IAH5cgWjuap7IPcF+LTA/LgG8OtmT+cRon72lW8iALD4xNdUZoafXpPwTM0WIBDT2m4YYAu+uBGVrvFeqbL/AZ90CrpUCCEnj3BPShW71c016RIZfFbAjRGxqRt82FiA8650g/SOGQb8nlrXRLwyZaiFz0HpISzFM3sJO7BPQDIXqlEXZfWWEsMcFa60rQYrQl7CwI0PO7RnhoU79+ky7BscBG47kRqABeG7K9QG9Lb4SeeD+Ivy0Gbtt9cQnm69Z6xYKEkirgnZFt0JBjb3U1/pADtwo44dcbNxdX6m3uoRrepTc8wWlgHzBen/tr2pO4OVJPvY0fusB6/+niE7wS4Uc1PrJSJZBnyeViPt+oYHyRTphxQYXWivaV4DAwJoocBsESh6umKyT0TAGOAneBQYZeo7qApMJPLvZki69pddL8Hz4e9QR6Wa4j9xW5dsqhuRzXoBiS4+19fvMqiXQg31QkVcpBuqpZIdnCgT86HKyssTJgDAAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpi);
export default __webpack_public_path__ + "static/media/ppi.5694425c.svg";
export { ForwardRef as ReactComponent };